import HomePage from '@/views/HomePage.vue';
import WorksMian from '@/views/main/WorksMian.vue';
import UploadMian from '@/views/main/UploadMian.vue';
import NavigationBar from '@/views/navigation/NavigationBar.vue';
import InformationMian from '@/views/main/InformationMian.vue';
import PersonView from '@/views/person/PersonView.vue';
import CollectionMian from '@/views/main/CollectionMian.vue';
import TeacherMian from '@/views/main/TeacherMian.vue';
import CoursesMian from '@/views/main/CoursesMian.vue';
import Teacher from '@/views/cha/TeacherMian.vue';
import MajorsMian from '@/views/main/MajorsMian.vue';
import Informtion from '@/views/cha/StudentFormaTion.vue';
import Courses from '@/views/cha/CoursesCou.vue';
import classeMian from '@/views/main/ClassesMian.vue';
import ClassMian from '@/views/cha/ClassMian.vue';
import MajorsView from '@/views/cha/MajorsView.vue';
import UserMian1 from '@/views/cha/UserMian.vue';
import { mapState } from "vuex";
import UserMian from '@/views/main/UserMian.vue';
import store from '@/store';
import WorksUser from '@/views/main/WorksUser.vue';
import { getInfo } from '@/api/login';
import WorkComments from '@/views/main/WorkComments.vue';
import WorkMain from '@/views/cha/WorkMain.vue';
import StageMian from '@/views/main/StageMian.vue';

// 导入学生学分模块
import StudentCredit from '@/views/main/system/student/index.vue';
// 导入学校规则模块
import CreditRules from '@/views/main/system/rules/index.vue';
//导入学分记录模块
import CreditLog from '@/views/main/system/logs/index.vue';

//导入我的学分模块
import MyCredit from '@/views/main/MyCredit.vue';

export default {
    components: {
        Teacher,  //教师
        NavigationBar,//导航栏
        PersonView,//个人
        Informtion,//
        Courses,//课程
        MajorsView,//专业
        ClassMian,//班级
        UserMian1,//用户
        WorkMain,//作品
        StageMian,//阶段 
        StudentCredit,//学生学分
        CreditRules,//学分规则
        CreditLog,//学分记录
        MyCredit,//我的学分表
    },
    computed: {
        ...mapState('page', ['CurrentPage']),
        currentPageComponent() {
            switch (this.CurrentPage) {
                case 'home':
                    return HomePage
                case 'teacher':
                    return TeacherMian
                case 'courses':
                    return CoursesMian
                case 'majors':
                    return MajorsMian
                case 'collection':
                    return CollectionMian
                case 'inform':
                    return InformationMian
                case 'upload':
                    return UploadMian
                case 'classe':
                    return classeMian
                case 'worksuser':
                    return WorksUser
                case 'workcomm':
                    return WorkComments
                case 'works':
                    return WorksMian
                case 'users':
                    return UserMian
                case 'stageconfig':
                    return StageMian
                case 'studentcredit': return StudentCredit;
                case 'creditrules': return CreditRules;
                case 'creditlog': return CreditLog;
                case 'mycredit':return MyCredit;
                default:
                    return HomePage
            }
        },
        Page() {
            return this.CurrentPage;
        },
        currentBreadcrumb() {
            switch (this.CurrentPage) {
                case 'teacher': return '教师管理';
                case 'inform': return '学生管理';
                case 'courses': return '课程管理';
                case 'majors': return '专业管理';
                case 'classe': return '班级管理';
                case 'users': return '用户管理';
                case 'works': return '作品管理';
                case 'worksuser': return '作品展示';
                case 'workcomm': return '作品详情';
                case 'stageconfig': return '阶段名称配置';
                case 'home': return '学校简介';
                case 'studentcredit': return '学生学分';
                case 'creditrules': return '学分规则';
                case 'creditlog': return '学分记录明细';
                case 'mycredit': return '我的学分';
                default: return '';
            }
        }

    },
    watch: {
        drawer(newValue) {
            if (newValue === false) {
                this.setUserProfile();
            }
        }
    },
    created() {
        store.commit('page/setPage', 'home')
        this.setUserProfile()

    },
    data() {
        return {
            isCollapse: true,
            drawer: false,
            imageUrl: '',
            name: '',
            deptName: '',
            defaultAvatar: 'https://oumandi.oss-cn-beijing.aliyuncs.com/2025/06/29/34948880_20250629175114A002.jpg',
            nickName: ''
        };
    },
    methods: {

        getimage(url) {
            // 即使后台有头像，也可能存在临时为空的情况，这里做双重校验
            if (!url || url.trim() === '' || url === 'null' || url === 'undefined') {
                return this.defaultAvatar;
            }
            // return process.env.VUE_APP_BASE_API + url;
            return url;
        },
        setUserProfile() {
            getInfo().then(res => {
                if (res.code === 200) {
                    // console.log("nihao");
                    // console.log(res);
                    // this.name = res.user.s
                    this.imageUrl = res.user.avatar;
                    this.deptName = res.user.dept.deptName;
                    this.nickName = res.user.nickName;
                }
            })
        },
        expand() {
            this.isCollapse = !this.isCollapse;
        },
        changePage(newPage) {
            this.$store.dispatch('changePage', newPage);
        },
        showDialog() {
            this.drawer = true;
        }
    },
    mounted() {
        const storedIdentity = sessionStorage.getItem('identity');
        if (storedIdentity) {
            this.$store.commit('setIdentity', storedIdentity);
        }
    }
};
